import { render, staticRenderFns } from "./shopStore.vue?vue&type=template&id=537463d8&scoped=true"
import script from "./shopStore.vue?vue&type=script&lang=js"
export * from "./shopStore.vue?vue&type=script&lang=js"
import style0 from "./shopStore.vue?vue&type=style&index=0&id=537463d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537463d8",
  null
  
)

export default component.exports